module.exports = __webpack_public_path__ + "img/qr.c53dd023.png";